<template>
  <div style="background: #f5f5f5">
    <top></top>
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="item in newinfoListB" :key="item">
        <img :src="item.image" alt="" @click="newsInfo_Btn(item.url)" />
      </el-carousel-item>
    </el-carousel>
    <div class="container">
      <breadcrumb :url="url"></breadcrumb>
      <div class="newInfo" v-for="(item, index) in orderData" :key="index">
        <div class="info_img">
          <img :src="item.image" alt="" />
        </div>
        <div class="info_text">
          <span class="span1">{{ item.title }}</span>
          <span class="span2">
            {{ item.content_text }}
          </span>
          <el-button class="span3" @click="newInfobtn(item.id)"
            >查看详情</el-button
          >
        </div>
        <div class="info_time">
          <span class="span1">{{ item.time }}</span>

        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="shopp_pagination">
      <el-button
        size="small"
        style="width: 80px; height: 40px"
        @click="pervious"
        >上一页</el-button
      >
      <el-pagination
        ref="pageGroup"
        :current-page="currentPage"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        background
        layout="pager"
        :total="total"
      >
      </el-pagination>
      <el-button style="width: 80px; height: 40px" size="small" @click="next"
        >下一页</el-button
      >
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";
import { informationIndex, banners_pc } from "@/api/index.js";
import { timestampToTime } from "@/util/util.js";
export default {
  data() {
    return {
      url: [{ name: "最新资讯", url: "/newinfo" }],
      newInfoList: [],
      pageSize: 5,
      total: 1,
      currentPage: 1,
      newinfoListB: [],
    };
  },
  created() {
    this.getInfoNewLIst();
    this.newBanner();
  },
  methods: {
    //最新资讯
    getInfoNewLIst() {
      informationIndex({}).then((res) => {
        console.log(res);
         res.data.lists.forEach((i) => {
          i.time = timestampToTime(i.createtime * 1000);
        });
        this.newInfoList = res.data.lists;
        console.log(this.newInfoList);
        this.total = res.data.count;
      });
    },
    //bannner
    newBanner() {
      banners_pc({ status: "News" }).then((res) => {

        this.newinfoListB = res.data.lists;
        console.log(res);
      });
    },
    //上一页
    pervious() {
      this.$refs.pageGroup.prev();
    },
    //下一页
    next() {
      this.$refs.pageGroup.next();
    },
    handleCurrentChange(newNum) {
      this.currentPage = newNum;
    },
    newInfobtn(id) {
      this.newInfoList.forEach((item) => {
        console.log(item.content);
        if (item.id === id) {
          this.$router.push({
            path: "/newInfoDetail",
            query: { content: item.id },
          });
        }
      });
    },
    newsInfo_Btn() {
      if (url == "") {
        return;
      }
      window.open(url);
    },
  },
  components: {
    top,
    breadcrumb,
    bottom,
  },
  computed: {
    orderData: function () {
      return this.newInfoList.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
  },
};
</script>
<style lang="less" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;

  line-height: 300px;
  margin: 0;
}
/deep/.el-carousel__container {
  height: 500px !important;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.newInfo {
  border-bottom: 1px solid #d8d8d8;
  display: flex;
  margin-bottom: 40px;
  padding-bottom: 20px;
  .info_img {
    width: 269px;
    height: 191px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info_text {
    display: flex;
    flex-direction: column;
    margin-left: 48px;

    .span1 {
      height: 38px;
      font-size: 28px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #333333;
      line-height: 42px;
      margin-bottom: 10px;
    }
    .span2 {
      width: 534px;
      height: 104px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #666666;
      line-height: 26px;
      margin-bottom: 5px;
      padding-right: 81px;
      border-right: 1px solid #bdbdbd;
    }
    .span3 {
      width: 106px;
      height: 35px;
      border-radius: 6px;
      border: 1px solid #0097fe;
    }
  }
  .info_time {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 70px;
    .span1 {
    //   width: 107px;
    //   height: 48px;
      font-size: 18px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      line-height: 72px;
      margin-bottom: 5px;
    }
    .span2 {
      width: 58px;
      height: 22px;
      font-size: 22px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
    }
  }
}
.el-pagination {
  display: flex;
  justify-content: center;
}
.shopp_pagination {
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
}
/deep/ .el-pager li {
  width: 40px !important;
  height: 38px !important;
  line-height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/index/newinfo.vue